import {
  BROADCAST_JOIN_MEETING,
  BROADCAST_LEAVE_MEETING,
  BROADCAST_SET_ATTENDEE_TILE,
  BROADCAST_SET_MIXER_TILE,
  BROADCAST_SET_MIXER_ATTENDEE,
  BROADCAST_UPDATE_ATTENDEE_PRESENCE,
  RENEW_MEETING,
  BROADCAST_JOIN_MEETING_AS_PRESENTER,
  BROADCAST_AGORA_TOGGLE_SCREEN_ACTIVE
} from 'actions/Types';
import {
  UPDATE_MEETING_STATUS,
  BROADCAST_CREATE_MEETING,
  ADD_TO_ATTENDEE_TILES
} from '@shoflo/studio-redux/actions/types';
import { MEETING_STATUS, VENDOR_AGORA } from '@studio/constants';
import { shouldJoinWithoutKnock } from '../utils/broadcastPresenterHelper';
import { shouldHaveFeature } from '@studio/feature.flags';

const initialState = {
  attendeeTiles: {},
  mixerTile: null,
  mixerAttendeeIds: [],
  attendeeId: null,
  meetingId: null,
  started: false,
  screenShare: {
    client: null,
    videoTrack: null,
    audioTrack: null
  },
  status: MEETING_STATUS.PENDING
};

function meeting(state = initialState, action) {
  const shouldRemoveKnockToJoinEnabled = shouldJoinWithoutKnock();
  const useAgora = shouldHaveFeature('studio.meetingVendor') === VENDOR_AGORA;
  if (
    action.type === `${BROADCAST_JOIN_MEETING}` &&
    !shouldRemoveKnockToJoinEnabled
  ) {
    return { ...state, ...action.payload, started: true };
  }

  if (
    action.type === `${BROADCAST_JOIN_MEETING}_SUCCESS` &&
    shouldRemoveKnockToJoinEnabled
  ) {
    return { ...state, ...action.payload, started: true };
  }

  if (
    action.type === `${BROADCAST_CREATE_MEETING}_SUCCESS` &&
    shouldRemoveKnockToJoinEnabled &&
    useAgora
  ) {
    return {
      ...state,
      ...action.payload,
      started: true,
      status: MEETING_STATUS.STARTED
    };
  }

  if (action.type === `${BROADCAST_CREATE_MEETING}_SUCCESS`) {
    return { ...state, ...action.payload };
  }

  if (action.type === BROADCAST_JOIN_MEETING_AS_PRESENTER) {
    return { ...state, ...action.payload };
  }

  if (action.type === `${BROADCAST_LEAVE_MEETING}`) {
    return { ...initialState };
  }

  if (action.type === `${BROADCAST_SET_MIXER_TILE}`) {
    const tileState = action.payload;

    return { ...state, mixerTile: tileState };
  }

  if (action.type === ADD_TO_ATTENDEE_TILES) {
    const { attendeeTile, attendeeId } = action.payload;
    return {
      ...state,
      attendeeTiles: {
        ...state.attendeeTiles,
        [attendeeId]: attendeeTile
      }
    };
  }

  if (action.type === `${BROADCAST_SET_ATTENDEE_TILE}`) {
    const tileState = action.payload;

    const nextState = { ...state };

    //Just support ONE tile atm, but need to account for multiple for screen/content share
    nextState.attendeeTiles[tileState.boundAttendeeId] = [tileState];

    return nextState;
  }

  if (action.type === `${BROADCAST_UPDATE_ATTENDEE_PRESENCE}`) {
    const { present, attendeeId } = action.payload;

    if (present) {
      return state;
    }

    const nextState = { ...state };

    delete nextState.attendeeTiles[attendeeId];

    return nextState;
  }

  if (action.type === `${BROADCAST_AGORA_TOGGLE_SCREEN_ACTIVE}_SUCCESS`) {
    const { screenShareClient, screenVideoTrack, screenAudioTrack } =
      action.payload;
    return {
      ...state,
      screenShare: {
        client: screenShareClient,
        videoTrack: screenVideoTrack,
        audioTrack: screenAudioTrack
      }
    };
  }

  if (action.type === BROADCAST_SET_MIXER_ATTENDEE) {
    return {
      ...state,
      mixerAttendeeIds: [...state.mixerAttendeeIds, action.payload]
    };
  }

  if (action.type === RENEW_MEETING) {
    return { ...state, ...action.payload };
  }

  if (action.type === UPDATE_MEETING_STATUS) {
    return {
      ...state,
      started: action.payload === MEETING_STATUS.STARTED,
      status: action.payload
    };
  }

  return state;
}

export default meeting;
